import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
